<div
  class="custom-alert custom-alert-{{ type }}"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId"
  [attr.aria-describedby]="bodyId"
>
  <!-- Loading modal has a different structure -->
  <div *ngIf="type === 'loading'" class="loading-container">
    <div class="loading-content">
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
      <div class="loading-title">{{ title || "Cargando..." }}</div>
      <div class="loading-message" *ngIf="message">{{ message }}</div>
    </div>
  </div>

  <!-- Regular modal structure for non-loading types -->
  <ng-container *ngIf="type !== 'loading'">
    <div class="header">
      <div class="icon" aria-hidden="true">
        <ng-container [ngSwitch]="type">
          <div *ngSwitchCase="'error'">
            <img
              src="/assets/icons/alert-error.svg"
              alt="Error"
              aria-hidden="true"
              width="30"
              height="30"
            />
          </div>
          <div *ngSwitchCase="'success'">
            <img
              src="/assets/icons/alert-success.svg"
              alt="Éxito"
              aria-hidden="true"
              width="30"
              height="30"
            />
          </div>
          <div *ngSwitchCase="'info'">
            <img
              src="/assets/icons/alert-info.svg"
              alt="Información"
              aria-hidden="true"
              width="30"
              height="30"
            />
          </div>
          <div *ngSwitchCase="'warning'">
            <img
              src="/assets/icons/alert-warning-black.svg"
              alt="Alerta"
              aria-hidden="true"
              width="30"
              height="30"
            />
          </div>
          <div *ngSwitchCase="'confirm'">
            <img
              src="/assets/icons/alert-confirm-black.svg"
              alt="Confirmar"
              aria-hidden="true"
              width="30"
              height="30"
            />
          </div>
        </ng-container>
      </div>
      <div class="title" [id]="titleId">{{ title }}</div>
    </div>

    <div class="body" [id]="bodyId">
      <div *ngIf="!html">{{ message }}</div>
      <div *ngIf="html" [innerHTML]="html"></div>
    </div>

    <div class="footer">
      <button
        *ngIf="type === 'error'"
        class="btn btn-error"
        (click)="onConfirm()"
      >
        {{ confirmText }}
      </button>

      <button
        *ngIf="type === 'success'"
        class="btn btn-error"
        (click)="onConfirm()"
      >
        {{ confirmText }}
      </button>

      <button
        *ngIf="type === 'info'"
        class="btn btn-error"
        (click)="onConfirm()"
      >
        {{ confirmText }}
      </button>

      <ng-container *ngIf="type === 'warning'">
        <button *ngIf="showCancel" class="btn btn-error" (click)="onCancel()">
          {{ cancelText }}
        </button>
        <button class="btn btn-primary" (click)="onConfirm()">
          {{ confirmText }}
        </button>
      </ng-container>

      <ng-container *ngIf="type === 'confirm'">
        <button *ngIf="showCancel" class="btn btn-error" (click)="onCancel()">
          {{ cancelText }}
        </button>
        <button class="btn btn-confirm" (click)="onConfirm()">
          {{ confirmText }}
        </button>
      </ng-container>
    </div>
  </ng-container>
</div>
